import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCondition from './condition.reducer';

/**
 * Every selector tolerates a missing feature slice (`state?.`). Charts live in `wonder-bi-core` and
 * are mounted by specs and host apps that do not register `ConditionStoreModule`; without the guard
 * the first read throws instead of simply reporting "no conditions". Mirrors `chart.selectors`.
 */
export const selectConditionState = createFeatureSelector<fromCondition.State>(
  fromCondition.conditionFeatureKey
);

export const selectConditions = createSelector(
  selectConditionState,
  (state: fromCondition.State | undefined) => state?.conditions ?? []
);

/** Only ACTIVE conditions — the ones a chart or an event should act on. */
export const selectActiveConditions = createSelector(selectConditions, (conditions) =>
  conditions.filter((c) => c.status === 'ACTIVE')
);

export const selectCondition = (id: string) =>
  createSelector(selectConditions, (conditions) => conditions.find((c) => c.id === id) ?? null);

export const selectConditionsLoaded = createSelector(
  selectConditionState,
  (state: fromCondition.State | undefined) => state?.loaded ?? false
);

export const selectConditionsLoading = createSelector(
  selectConditionState,
  (state: fromCondition.State | undefined) => state?.loading ?? false
);

export const selectConditionError = createSelector(
  selectConditionState,
  (state: fromCondition.State | undefined) => state?.error ?? null
);
